module.exports = __webpack_public_path__ + "../resources/img/ic_mostly_cloudy_weather.5653b8ef.svg";